export const hasStemsAccess = (currentUser: User): boolean => {
	const isHighValueUser =
		currentUser?.organisation.serviceTier === 'Account Managed' ||
		currentUser?.organisation.serviceTier === 'VIP'

	return (
		currentUser?.isStaff ||
		(currentUser?.organisation.canDownload && isHighValueUser)
	)
}
